export default __webpack_public_path__ + "static/media/down-arrow.b7990345.svg";